/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    Table,
    Input,
    Form,
    Row,
    Col,
    Modal,
    message,
    InputNumber,
    Select,
    Card,
    Icon,
    DatePicker,
} from 'antd';
import { services } from '@comall-backend-builder/core';
import { navigation } from '@comall-backend-builder/core/lib/services';
import { errorHandle } from '../../services';
import './index.less';
import { isArray } from 'lodash';
const { RangePicker } = DatePicker;
const api = services.api;
const { Option } = Select;

const ChangePriceSelectorProps: React.FC<any> = ({ form }) => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [total, setTotal] = useState<any>(0);
    const [sortValue, setSortValue] = useState<any>('');
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchValue, setSearchValue] = useState<any>({});
    const [visible, setVisible] = useState<any>(false);
    const isInit = useRef(false); // 是否初始化
    const { confirm } = Modal;

    useEffect(() => {
        loadSknList(1, 10);
        isInit.current = true;
        return () => {
            isInit.current = false;
        };
    }, []);

    useEffect(() => {
        if (isInit.current) {
            setPageNum(1);
            loadSknList(1, pageSize);
        }
    }, [searchValue]);

    // 获取数据
    const loadSknList = (page: number, per_page: number) => {
        setLoading(true);
        api.get({ ...searchValue, page, per_page }, { apiPath: `/page/floatingLayer/getLst` })
            .then((res: any) => {
                const { result, totalNum } = res;
                setTableData(result || []);
                setLoading(false);
                setTotal(totalNum);
            })
            .catch(errorHandle);
    };

    const getFields = () => {
        const { getFieldDecorator } = form;
        const children = [
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={`编号`} labelCol={{ span: 8 }}>
                        {getFieldDecorator(`id`)(<Input placeholder="请输入" />)}
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item label={`状态`} labelCol={{ span: 8 }}>
                        {getFieldDecorator(`enabled`)(
                            <Select placeholder="请选择">
                                <Option value={0}>启用</Option>
                                <Option value={1}>停用</Option>
                                <Option value={2}>草稿</Option>
                            </Select>
                        )}
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item label={`名称`} labelCol={{ span: 8 }}>
                        {getFieldDecorator(`name`)(<Input placeholder="请输入" />)}
                    </Form.Item>
                </Col>
            </Row>,
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label="创建时间" labelCol={{ span: 8 }}>
                        {getFieldDecorator('createTime')(<RangePicker showTime />)}
                    </Form.Item>
                </Col>
            </Row>,
        ];
        return children;
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        form.validateFields((_err: any, values: any) => {
            const params = { ...values };
            if (params?.enabled === 2) {
                params.draft = 0;
                delete params.enabled;
            } else if (params?.enabled === 0 || params?.enabled === 1) {
                params.draft = 1;
            }
            const createTime = params?.createTime;
            if (isArray(createTime) && createTime.length) {
                params.startTime = createTime[0].format('YYYY-MM-DD HH:mm:ss');
                params.endTime = createTime[1].format('YYYY-MM-DD HH:mm:ss');
            }
            setSearchValue(params);
        });
    };

    const handleReset = () => {
        form.resetFields();
        setSearchValue({});
    };

    const handleSuccessReset = (value: string) => {
        message.success(value);
        setPageNum(1);
        setSelectedRowKeys([]);
        loadSknList(1, pageSize);
    };

    // 新增
    const handleAdd = () => {
        let path = `/design/floatingLayer/add`;
        navigation.goto(path);
    };

    // 删除
    const showDeleteConfirm = (id) => {
        confirm({
            title: '确定要删除吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                services.api
                    .delete({}, { apiPath: `/page/floatingLayer/${id}` })
                    .then(() => {
                        message.success('删除成功！');
                        loadSknList(1, pageSize);
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    // 查看
    const handleSee = (record: { id: any }) => {
        let path = `/design/floatingLayer/detail/${record.id}/1`;
        navigation.goto(path);
    };

    // 编辑
    const handleEdit = (record: { id: any }) => {
        let path = `/design/floatingLayer/edit/${record.id}/0`;
        navigation.goto(path);
    };

    const columns: any[] = [
        {
            title: '编号',
            dataIndex: 'id',
            width: '10%',
            align: 'center',
        },
        {
            title: '名称',
            dataIndex: 'name',
            width: '20%',
        },
        {
            title: '内容描述',
            dataIndex: 'floatDescribe',
            width: '25%',
        },

        {
            title: '页面排序',
            dataIndex: 'orders',
            align: 'center',
            width: '10%',
        },
        {
            title: '显示状态',
            dataIndex: 'enabled',
            width: '15%',
            render: (enabled: any, record: any) => {
                return record.draft === 0 ? (
                    <div className="draft-icon">草稿</div>
                ) : enabled === 1 ? (
                    <div className="hide-icon">停用</div>
                ) : (
                    <div className="display-icon">启用</div>
                );
            },
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '25%',
        },
        {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 150,
            align: 'center',
            render: (_: any, record: any) => (
                <div>
                    <a type="link" onClick={() => handleEdit(record)}>
                        编辑
                    </a>
                    {record.draft === 0 ? (
                        <a
                            type="link"
                            style={{ marginLeft: 8 }}
                            onClick={() => showDeleteConfirm(record.id)}
                        >
                            删除
                        </a>
                    ) : null}
                    <a type="link" style={{ marginLeft: 8 }} onClick={() => handleSee(record)}>
                        查看
                    </a>
                </div>
            ),
        },
    ];

    const onShowSizeChange = (_current: any, size: any) => {
        setPageNum(1);
        setPageSize(size);
        loadSknList(1, size);
    };

    useEffect(() => {
        setSortValue('');
    }, [visible]);

    // 改变分页
    const handlePageChange = (current: number, size: number) => {
        setPageNum(current);
        setPageSize(size);
        loadSknList(current, size);
    };

    return (
        <Card title="首页浮层管理">
            <div className="sunbathing-box">
                <Form
                    className="ant-advanced-search-form"
                    style={{ marginBottom: '24px' }}
                    onSubmit={handleSearch}
                >
                    {getFields()}
                    <Row>
                        <Col span={12}>
                            <Button onClick={handleAdd} type="primary">
                                <Icon type="plus" />
                                新建
                            </Button>
                        </Col>

                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                                重置
                            </Button>
                            {/* <a style={{ marginLeft: 8, fontSize: 12 }} onClick={toggle}>
                                {expand ? '收起' : '展开'} <Icon type={expand ? 'up' : 'down'} />
                            </a> */}
                        </Col>
                    </Row>
                </Form>
                <Table
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    dataSource={tableData}
                    pagination={{
                        current: pageNum, //当前页码
                        pageSize, // 每页数据条数
                        showSizeChanger: true,
                        showQuickJumper: false,
                        pageSizeOptions: ['10', '15', '20'],
                        total: total,
                        onShowSizeChange: onShowSizeChange,
                        onChange: handlePageChange,
                        showTotal: (total, range) => `第${range[0]}-${range[1]}条/总共${total}条`,
                    }}
                />

                <Modal
                    width={400}
                    centered
                    visible={visible}
                    title="批量设置排序"
                    onCancel={() => {
                        setVisible(false);
                    }}
                    footer={[
                        <Button
                            key="back"
                            onClick={() => {
                                setVisible(false);
                            }}
                        >
                            取消
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={loading}
                            onClick={() => {
                                if (!sortValue) {
                                    message.warning('排序值不能为空');
                                    return;
                                }
                                api.put(
                                    { sortValue: sortValue, list: selectedRowKeys },
                                    { apiPath: `/review_list/sort` }
                                )
                                    .then(() => {
                                        handleSuccessReset('批量设置排序成功！');
                                        setVisible(false);
                                    })
                                    .catch(errorHandle);
                            }}
                        >
                            确定
                        </Button>,
                    ]}
                >
                    <div className="sunbathing-sort">
                        <div className="sort-title">
                            已选{selectedRowKeys.length}条数据，将会批量更新为以下排序。
                        </div>
                        <div className="sort-content">
                            <div className="label">设置排序：</div>
                            <div className="value">
                                <InputNumber
                                    max={999}
                                    value={sortValue}
                                    placeholder="请输入数值"
                                    onChange={(e) => {
                                        setSortValue(e);
                                    }}
                                />
                                {!sortValue && <div className="value-errIcon">排序值不能为空</div>}
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </Card>
    );
};

export const FloatingLayerView = Form.create<any>()(ChangePriceSelectorProps);
export default FloatingLayerView;
